export { Table } from './Table';
export type {
  TableCellProps,
  TableColumn,
  TableColumns,
  TableProps,
} from './Table';
